import { render } from "./score.vue?vue&type=template&id=12ef0364&scoped=true&ts=true"
import script from "./score.vue?vue&type=script&lang=ts"
export * from "./score.vue?vue&type=script&lang=ts"

import "./score.vue?vue&type=style&index=0&id=12ef0364&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ef0364"]])

export default __exports__